import React, { useEffect, useState } from "react";
import Select from "react-select";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./tenant-allocation.css";
import tenantService from "../services/tenantService";
import userService from "../services/userService";
import { useStateContext } from "../contexts/ContextProvider";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

function TenantAllocation() {
  const { currentColor, currentMode } = useStateContext();
  const [userArr, setUserArr] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedValuesunallocate, setSelectedValuesunallocate] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [Rows, setRows] = useState([]);
  const [newRows, setnewRows] = useState([]);
  const [AllocatedMembers, setAllocatedmembers] = useState([]);

  const fetchUsers = async (role) => {
    try {
      const data = await userService.getUsersByrole({});
      setUserArr(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    const checked = event.target.checked;
    console.log(checked, "-----------", value);
    if (value === "selectAll") {
      if (checked) {
        const allClientIds = newRows.map((item) => item._id);
        console.log(allClientIds);
        setSelectedValues(allClientIds);
      } else {
        setSelectedValues([]);
      }
    } else {
      setSelectedValues((prevSelectedValues) => {
        if (checked) {
          return [...prevSelectedValues, value];
        } else {
          return prevSelectedValues.filter(
            (selectedValue) => selectedValue !== value
          );
        }
      });
    }
  };

  const handleSelectChangeunAllocate = (event) => {
    const value = event.target.value;
    const checked = event.target.checked;
    console.log(checked, value);

    if (value === "selectAll") {
      if (checked) {
        const allClientIds = AllocatedMembers.map((item) => item._id);
        setSelectedValuesunallocate(allClientIds);
      } else {
        setSelectedValuesunallocate([]);
      }
    } else {
      setSelectedValuesunallocate((prevSelectedValues) => {
        if (checked) {
          return [...prevSelectedValues, value];
        } else {
          return prevSelectedValues.filter(
            (selectedValue) => selectedValue !== value
          );
        }
      });
    }
  };

  const handleButtonClick = () => {
    console.log(selectedValues);
    let users = userArr.filter((o) => selectedValues.includes(o._id));
    setAllocatedmembers((prevAllocatedMembers) => {
      // Convert prevAllocatedMembers to a Set to remove duplicates
      const uniqueMembers = new Set(
        prevAllocatedMembers.map((member) => member._id)
      );

      // Add each user from the 'users' array to the Set if it's not already present
      users.forEach((user) => {
        if (!uniqueMembers.has(user._id)) {
          uniqueMembers.add(user._id);
          prevAllocatedMembers.push(user);
        }
      });

      return prevAllocatedMembers;
    });

    // Filter out selectedValues from setnewRows and setRows
    setnewRows((prevNewRows) =>
      prevNewRows.filter((row) => !selectedValues.includes(row._id))
    );
    setRows((prevRows) =>
      prevRows.filter((row) => !selectedValues.includes(row._id))
    );
  };

  const finalAllocation = async () => {
    console.log(selectedProject);
    let Finalemployees = AllocatedMembers.map((o) => o._id);
    console.log(Finalemployees);
    console.log(selectedProject);
    const tenantId = selectedProject["value"];
    const tenant = projectList.find((o) => o._id === tenantId);
    tenant["users"] = Finalemployees;
    const tenantUpdate = await tenantService.updatetenant(tenantId, tenant);
    if (tenantUpdate.success) {
      toast.success(`Tenant updation success`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(`Error in updating Tenant`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleButtonClickunAllocate = () => {
    // Filter users based on selectedValuesunallocate
    let usersToUnallocate = userArr.filter((user) =>
      selectedValuesunallocate.includes(user._id)
    );

    // Update allocated members by removing usersToUnallocate
    setAllocatedmembers((prevAllocatedMembers) =>
      prevAllocatedMembers.filter(
        (member) => !selectedValuesunallocate.includes(member._id)
      )
    );

    // Add usersToUnallocate to newRows, ensuring uniqueness
    setnewRows((prevNewRows) => {
      const uniqueNewRows = new Set([...prevNewRows, ...usersToUnallocate]);
      return Array.from(uniqueNewRows);
    });

    // Add usersToUnallocate to Rows, ensuring uniqueness
    setRows((prevRows) => {
      const uniqueRows = new Set([...prevRows, ...usersToUnallocate]);
      return Array.from(uniqueRows);
    });
  };

  const getData = async (tenantId) => {
    setRows([]);
    setAllocatedmembers([]);
    setnewRows([]);
    console.log(projectList);
    const currentTenant = projectList.find((o) => o._id === tenantId);
    console.log(userArr);
    let unallocatedMembers = userArr.filter((user) => {
      console.log(currentTenant["users"]);
      // Check if the current user's _id is not included in currentTenant['users']
      return !currentTenant["users"].includes(user._id);
    });

    let allocatedMembers = userArr.filter((user) => {
      console.log(currentTenant["users"]);
      // Check if the current user's _id is not included in currentTenant['users']
      return currentTenant["users"].includes(user._id);
    });

    console.log(unallocatedMembers, currentTenant);
    setRows(unallocatedMembers);
    setAllocatedmembers(allocatedMembers);
    setnewRows(unallocatedMembers);
  };

  const fetchdata = async () => {
    try {
      const data = await tenantService.gettenants(); // Corrected function name
      // setTenant(data);
      setProjectList(data);
      const usersArr = await userService.getAllUsers({});
      setUserArr(usersArr);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  function handleTenantChange(valuesArray) {
    console.log(valuesArray);
    setSelectedProject(valuesArray);
    getData(valuesArray.value);
  }

  const projectOptions = projectList.map((value) => ({
    label: value.clientName,
    value: value._id,
  }));

  useEffect(() => {
    fetchdata();
  }, []);
  // useEffect(() => {}, [Rows, newRows, AllocatedMembers]);

  return (
    <>
      <ToastContainer />
      <div className="full-layout">
        <div className="row mt-1 justify-center">
          <div className="col-4">
            <label
              className="ml-5 mb-3 mt-3 font-bold"
              style={{ color: currentColor, borderColor: currentColor }}
            >
              Clients{" "}
            </label>
            <Select
              options={projectOptions}
              onChange={(selectedOption) => handleTenantChange(selectedOption)}
              menuPortalTarget={document.body}
              value={selectedProject}
              isSearchable
              className="ml-5"
              style={{ color: currentColor, borderColor: currentColor }}
            />
          </div>
        </div>
        <div className="row justify-center">
          <div className="col-4">
            <div className="row mt-2 ml-7">
              <div
                className="col-md-12 table-container ml-8 mt-3"
                style={{
                  minWidth: "300px",
                  minHeight: "400px",
                  border: `1px solid  ${
                    currentMode === "Dark" ? "white" : currentColor
                  }`,
                  borderRadius: "5px",

                  backgroundColor: currentMode === "Dark" ? "#33373E" : "white",
                }}
              >
                <table className="animated-table">
                  <thead
                    className="thead ml-3"
                    style={{
                      color: currentMode === "Dark" ? "white" : currentColor,
                    }}
                  >
                    <tr>
                      <th
                        className="animated-cell paname whitespace-nowrap"
                        style={{
                          color:
                            currentMode === "Dark" ? "white" : currentColor,
                        }}
                      >
                        All users
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tbody">
                    <tr>
                      <TooltipComponent
                        content="select all"
                        position="BottomCenter"
                      >
                        <td className="pacheckbox">
                          <input
                            type="checkbox"
                            value="selectAll"
                            checked={
                              selectedValues.length === newRows.length &&
                              newRows.length
                            }
                            onChange={handleSelectChange}
                          />
                        </td>
                      </TooltipComponent>
                      <td className={`animated-cell paname  ${currentMode === "Dark"
  ? "bg-custom-dark-bg text-white"
  : "bg-white text-gray-800"
}`}>select all</td>
                    </tr>
                    {newRows.map((item) => (
                      <tr key={item._id}>
                        <td className="pacheckbox">
                          <input
                            type="checkbox"
                            value={item._id}
                            checked={selectedValues.includes(item._id)}
                            onChange={handleSelectChange}
                          />
                        </td>
                        <td className={`animated-cell paname  ${currentMode === "Dark"
  ? "bg-custom-dark-bg text-white"
  : "bg-white text-gray-800"
}`}
>
                          {item.firstname} {item.lastname} (
                          {item.role?.name || ""})
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-3 ">
            <div className="d-flex flex-column align-items-center buttonmiddle">
              <div className="row mb-4">
                <div className="col-md-12 ">
                  <button
                    disabled={!selectedValues.length}
                    className="btn"
                    onClick={handleButtonClick}
                    style={{
                      color: currentMode === "Dark" ? "white" : currentColor,
                      borderColor:
                        currentMode === "Dark" ? "white" : currentColor,
                    }}
                  >
                    <FaArrowRight />
                  </button>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12 mb-6">
                  <button
                    disabled={!selectedValuesunallocate.length}
                    className="btn"
                    onClick={handleButtonClickunAllocate}
                    style={{
                      color: currentMode === "Dark" ? "white" : currentColor,
                      borderColor:
                        currentMode === "Dark" ? "white" : currentColor,
                    }}
                  >
                    <FaArrowLeft />
                  </button>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-12 mb-6">
                  <button
                    disabled={!AllocatedMembers.length}
                    className="btn"
                    onClick={finalAllocation}
                    style={{
                      color: currentMode === "Dark" ? "white" : currentColor,
                      borderColor:
                        currentMode === "Dark" ? "white" : currentColor,
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="row mt-2">
              <div
                className="col-md-12 mt-3 table-container"
                style={{
                  minWidth: "300px",
                  minHeight: "400px",
                  border: `1px solid  ${
                    currentMode === "Dark" ? "white" : currentColor
                  }`,
                  borderRadius: "5px",
                  backgroundColor: currentMode === "Dark" ? "#33373E" : "white",
                }}
              >
                <table className="animated-table">
                  <thead className="thead">
                    <tr>
                      <th
                        className="animated-cell paname whitespace-nowrap"
                        style={{
                          color:
                            currentMode === "Dark" ? "white" : currentColor,
                        }}
                      >
                        Assigned users
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tbody">
                    <tr>
                      <TooltipComponent
                        content="select all"
                        position="BottomCenter"
                      >
                        <td className="pacheckbox">
                          <input
                            type="checkbox"
                            value="selectAll"
                            checked={
                              selectedValuesunallocate.length ===
                                AllocatedMembers.length &&
                              AllocatedMembers.length
                            }
                            onChange={handleSelectChangeunAllocate}
                          />
                        </td>
                      </TooltipComponent>
                      <td className="animated-cell paname">select all</td>
                    </tr>
                    {AllocatedMembers.map((item) => (
                      <tr key={item._id}>
                        <td className="pacheckbox">
                          <input
                            type="checkbox"
                            value={item._id}
                            checked={selectedValuesunallocate.includes(
                              item._id
                            )}
                            onChange={handleSelectChangeunAllocate}
                          />
                        </td>
                        <td className="animated-cell paname">
                          {item.firstname} {item.lastname} (
                          {item.role?.name || ""})
                        </td>
                        {/* <td className="animated-cell">{item.employeeData?.employeeInfo?.functionalUnit}</td>
              <td className="animated-cell">{item.employeeData?.employeeInfo?.role}</td>
              <td className="animated-cell">{item.employeeData?.employeeInfo?.level}</td>            */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default TenantAllocation;
